export const extractNameHours = (realtors) => {
  let obj = {}
  for (let entry of Object.values(realtors)) {
    if (entry.meta.realtor === true) {
      if (entry.meta.hours) {
        obj[entry.meta.name] = Math.floor(entry.meta.hours/60)
      } else {
      obj[entry.meta.name] = 0
    }
  }
}
return obj
}



// WEBPACK FOOTER //
// ./src/components/dashboard/utils.js